import PaymentView from '@target/views/payment/PaymentView.vue';
import AuthErrorPage from "@target/views/auth-error/AuthErrorPage.vue";
import ChatView from "@/views/chat/ChatView.vue";
import NewPaymentView from "@/targets/light/components/popups/create-payment/NewPaymentView.vue";
import NewPaymentPopup from "@/targets/light/components/popups/create-payment/NewPaymentPopup.vue";

// Creating new payment
import PopupPaymentCreate from "@/components/popup/popup-payment-create/NewPaymentPopup.vue";
import ViewPaymentCreateConfig from "@/views/payment-create-config/NewPaymentView.vue";
import ViewPaymentCreateAgents from "@/targets/light/views/payment-create-agents/ViewPaymentCreateAgents.vue";
import PaymentToUpComplete from "@/targets/light/views/payment/PaymentToUpComplete.vue";
import ViewRules from "@/views/v2/rules/ViewRules.vue";
import CreatePaymentView from "@/targets/light/views/create-payment/CreatePaymentView.vue";
import SelectAgentPopup from "@/targets/light/components/popups/agents/SelectAgentPopup.vue";

const routes: any = [
  {
    path: '/popup/payment/create',
    popup: {
      component: PopupPaymentCreate,
    },
  },
  {
    path: '/rules',
    component: ViewRules,
  },
  {
    path: '/payment/create/config',
    component: ViewPaymentCreateConfig,
  },
  {
    path: '/payment/create/agents',
    component: ViewPaymentCreateAgents,
  },
  {
    path: '/popup/select-agent',
    popup: {
      component: SelectAgentPopup
    },
    options: {
      props: {
        payment: null,
      },
    },
  },
  {
    path: '/popup/main',
    popup: {
      component: NewPaymentPopup,
    },
    options: {
      props: {
        payment: null,
      },
    },
  },
  {
    path: '/popup/new-payment',
    component: NewPaymentView,
  },
  {
    path: '/auth-error',
    component: AuthErrorPage,
  },
  {
    path: '/chat',
    component: ChatView,
  },
  {
    path: '/payment',
    component: PaymentView,
    options: {
      props: {
        fromHistory: false,
      },
    },
  },
  {
    path: '/create-payment',
    component: CreatePaymentView,
    options: {
      props: {
        fromHistory: false,
      },
    },
  },
  {
    path: '/payment-to-up-complete',
    component: PaymentToUpComplete,
    options: {
      props: {
        fromHistory: false,
      },
    },
  },
];

export default routes;
